import {Component} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AiInsightTileComponent} from '@components/disinfection/ai-insight-tile/ai-insight-tile.component';
import {InventoryTileComponent} from '@components/disinfection/inventory-tile/inventory-tile.component';
import {CurrentScheduleTileComponent} from '@components/disinfection/current-schedule-tile/current-schedule-tile.component';
import {HistoryTileComponent} from '@components/disinfection/history-tile/history-tile.component';
import {TimelineTileComponent} from '@components/disinfection/timeline-tile/timeline-tile.component';

@Component({
    selector: 'app-insights-panel',
    standalone: true,
    imports: [
        CommonModule,
        AiInsightTileComponent,
        InventoryTileComponent,
        CurrentScheduleTileComponent,
        HistoryTileComponent,
        TimelineTileComponent
    ],
    templateUrl: './insights-panel.component.html',
    styleUrl: './insights-panel.component.scss'
})
export class InsightsPanelComponent {
    activeTab: string = 'current-schedule';

    tabs = [
        {id: 'current-schedule', label: 'Current Schedule'},
        {id: 'history', label: 'History'},
        {id: 'inventory', label: 'Inventory'},
        {id: 'ai-insights', label: 'AI Insights'},
        {id: 'timeline', label: 'Timeline'}
    ];

    setActiveTab(tabId: string): void {
        this.activeTab = tabId;
    }

    isActiveTab(tabId: string): boolean {
        return this.activeTab === tabId;
    }
}
